import { Component, OnInit, ViewChild } from "@angular/core";
import { AppService } from "src/app/core/app/app.service";
import { MdbTableDirective } from "ng-uikit-pro-standard";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { OrderFactoryDayOfWeekData } from "src/app/core/order/analytics/data/data.abstract";
import { VenueOrderFactory } from "src/app/core/order/order.factory.venue";
import { OrderFactory } from "src/app/core/order/order.factory";
import { OrderFactoryPeriodSummary } from "src/app/core/order/analytics/summaries/summary.abstract";

@Component({
  selector: "ll-summary-by-dow",
  templateUrl: "./summary-by-dow.component.html",
  styleUrls: ["./summary-by-dow.component.scss"]
})
export class SummaryByDowComponent implements OnInit {
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  public map: Map<number, string>;

  constructor(private app: AppService, private router: Router) {
    this.map = new Map();
    this.map.set(0, "Sunday");
    this.map.set(1, "Monday");
    this.map.set(2, "Tuesday");
    this.map.set(3, "Wednesday");
    this.map.set(4, "Thursday");
    this.map.set(5, "Friday");
    this.map.set(6, "Saturday");
  }
  ngOnInit() {}
  ngAfterViewInit() {}

  public get data$(): Observable<OrderFactoryDayOfWeekData[]> {
    return this.app.state.dowTableData$;
  }
  public get totals$(): Observable<OrderFactoryPeriodSummary> {
    return this.app.state.periodTotalData$;
  }
  get tDays(): number {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.days, 0);
  }
  get tUnits(): number {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.units, 0);
  }
  get tAvgPrice(): number {
    return 0;
    // return (
    //   this.data.reduce((acc, next) => acc + next.avgPrice * next.units, 0) /
    //   this.tUnits
    // );
  }

  get tSubtotal() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.subtotal, 0);
  }

  get tServiceFees() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.serviceFees, 0);
  }
  get tTips() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.tips, 0);
  }

  get tTotal() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.total, 0);
  }
  get tRedeemed() {
    return 0;
    // return this.data.reduce((acc, next) => acc + next.redeemed, 0);
  }

  get tTipPercentage() {
    return 0;
    // return this.tTips / this.tTotal;
  }
  //
  get tRedeemedPercentage() {
    return 0;
    // return this.tRedeemed / this.tUnits;
  }
  get tRevenue() {
    return 0;
    // return (
    //   this.data.reduce(
    //     (acc, next) => acc + next.total / this.analytics.revenue,
    //     0
    //   ) / this.data.length
    // );
  }
}
